import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { CalendarStatusType } from "src/helpers/Enums";

const Calendar = (props) => {

    const [currentMonth, setCurrentMonth] = useState(props.date.getMonth());
    const [currentYear, setCurrentYear] = useState(props.date.getFullYear());
    const [dayOfWeek, setDayOfWeek] = useState((new Date(props.date.getFullYear(), props.date.getMonth(), 1)).getDay());
    const [endDayOfWeek, setEndDayOfWeek] = useState((new Date(props.date.getFullYear(), props.date.getMonth() + 1, 0)).getDay());
    const [daysInPreviousMonth, setDaysInPreviousMonth] = useState(new Date(props.date.getFullYear(), props.date.getMonth(), 0).getDate())
    const [daysInMonth, setDaysInMonth] = useState(new Date(props.date.getFullYear(), props.date.getMonth() + 1, 0).getDate())
    const today = new Date();
    const [days, setDays] = useState(new Map())

    useEffect(() => {
        setCurrentMonth(props.date.getMonth())
        setCurrentYear(props.date.getFullYear())
        setDayOfWeek((new Date(props.date.getFullYear(), props.date.getMonth(), 1)).getDay())
        setEndDayOfWeek((new Date(props.date.getFullYear(), props.date.getMonth() + 1, 0)).getDay())
        setDaysInPreviousMonth(new Date(props.date.getFullYear(), props.date.getMonth(), 0).getDate())
        setDaysInMonth(new Date(props.date.getFullYear(), props.date.getMonth() + 1, 0).getDate())
    }, [props.date])

    useEffect(() => {
        const groups = new Map()

        props.list?.forEach((item) => {
            const dayKey = item?.date ? parseInt(item?.date.substring(8, 10), 10) : null;
            if (!groups.has(dayKey)) {
                groups.set(dayKey, []);
            }
            groups.get(dayKey).push(item);
        })
        setDays(groups)

    }, [props.list])

    const getItemsByKey = (key) => {
        if (days.has(key)) {
            return days.get(key);
        } else {
            return null;
        }
    }

    const getDayContent = (day) => {
        if (getItemsByKey(day) !== null) {
            let completed = []
            let scheduled = []
            let created = []
            {
                Array.from(getItemsByKey(day).entries()).map(([key, value]) => {
                    if (value?.status === CalendarStatusType.CREATED)
                        created.push(value)
                    else if (value?.status === CalendarStatusType.SCHEDULED)
                        scheduled.push(value)
                    else if (value?.status === CalendarStatusType.DONE)
                        completed.push(value)
                })
            }
            return (
                <button className={ "flex flex-col gap-1 w-full" }
                        onClick={ () => props.handleOpenCalendarDetail(day, getItemsByKey(day)) }>
                    { completed?.length > 0 &&
                        <div className={ "CalendarCompleteBox" }>
                            <img alt={ "Logo" } src={ "/media/icons/complete.svg" } className={ "w-4 h-4" }/>
                            { completed?.length } lists
                            <div className={ "CalendarCompleteBoxText" }>Completed</div>
                        </div>
                    }
                    { created?.length > 0 &&
                        <div className={ "CalendarCreatedBox" }>
                            <img alt={ "Logo" } src={ "/media/icons/createdIconPurple.svg" } className={ "w-4 h-4" }/>
                            { created?.length } lists
                            <div className={ "CalendarCreatedBoxText" }>Created</div>
                        </div>
                    }
                    { scheduled?.length > 0 &&
                        <div className={ "CalendarScheduledBox" }>
                            <img alt={ "Logo" } src={ "/media/icons/scheduledIconRed.svg" } className={ "w-4 h-4" }/>
                            { scheduled?.length } lists
                            <div className={ "CalendarScheduledBoxText" }>Scheduled</div>
                        </div>
                    }
                </button>
            )
        } else {
            if (isPastDay(day)) {
                return (
                    <div></div>
                )
            }
            return (
                <div className="CalendarDayBox">
                    <button className={ "CalendarAddButton" } onClick={ () => props.handleAddSchedule(day) }>+</button>
                </div>
            )
        }
    }

    const handlePreviousMonth = () => {
        if (currentMonth === 0) {
            props.setDate(new Date(currentYear - 1, 12, 0))
        } else {
            props.setDate(new Date(currentYear, currentMonth, 0))
        }
        props.setIsUpdate(true)
    }

    const handleNextMonth = () => {
        if (currentMonth === 11) {
            props.setDate(new Date(currentYear + 1, 1, 0))
            props.setIsUpdate(true)
        } else {
            props.setDate(new Date(currentYear, currentMonth + 2, 0))
            props.setIsUpdate(true)
        }
    }

    const isSameDay = (day) => {
        return (
            props.date.getFullYear() === today.getFullYear() &&
            props.date.getMonth() === today.getMonth() &&
            today.getDate() === day
        );
    };

    const isPastDay = (day) => {
        const d1 = new Date(props.date.getFullYear(), props.date.getMonth(), day);
        const d2 = new Date(today.getFullYear(), today.getMonth(), today.getDate());

        const dayDifference = (d1 - d2) / (1000 * 60 * 60 * 24);

        return dayDifference < 0;
    };

    return (
        <div className="TableWrapper">
            <div className="CalendarHeader">
                <button className={clsx("ChevronButtons", "ml-[16px]") } onClick={ handlePreviousMonth }>
                    <img alt={ "Logo" } src={ "/media/icons/chevronLeft.svg" } className={ "w-[18px] h-[18px]" }/>
                </button>
                <button className={clsx("ChevronButtons", "ml-[6px]") } onClick={ handleNextMonth }>
                    <img alt={ "Logo" } src={ "/media/icons/chevronRight.svg" } className={ "w-[18px] h-[18px]" }/>
                </button>
                <div className="text-base ml-3 font-semibold">{ props.date.toLocaleString("default", {
                    month: "short",
                    year: "numeric"
                }) }
                </div>
            </div>

            <div className="CalendarDaysLine">
                { ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((day) => (
                    <div key={ day } className={ "px-4 py-2 border-r border-b" }>{ day.toUpperCase() }</div>
                )) }
            </div>

            <div className="grid grid-cols-7 auto-rows-fr">
                { Array.from({length: dayOfWeek === 0 ? 6 : dayOfWeek - 1}).map((_, index) => (
                    <div key={ `empty-${ index }` }
                         className={ "p-[6px] min-h-[120px] flex-grow min-w-0 flex flex-col border-r border-b" }>
                        <div className={ "CalendarDayNumber" }>
                            { daysInPreviousMonth - dayOfWeek + index + 2 }
                        </div>
                    </div>
                )) }
                { Array.from({length: daysInMonth}, (_, index) => {
                    const day = index + 1;
                    return (
                        <div key={ day }
                             className={ clsx(`p-[6px] flex-grow min-w-0 flex flex-col border-r border-b h-full`, isSameDay(day) ? "border-4 border-t-4 border-l-4 border-b-4 border-r-4 border-[#7E50EA] rounded-lg" : "") }
                        >
                            {
                                isSameDay(day) ?
                                    <div>
                                        <div className={ "CalendarTodayNumberLine" }>
                                            <div className={ "CalendarTodayNumber" }>{ day }</div>
                                            <div className={ "CalendarToday" }>Today</div>
                                        </div>
                                        { getDayContent(day) }
                                    </div> :
                                    <div className={ "w-full" }>
                                        <div className={ "flex justify-between w-full" }>
                                            <div className={ "CalendarDayNumber" }>{ day }</div>
                                            { !isPastDay(day) && getItemsByKey(day) !== null &&
                                                <button onClick={() => props.handleDeleteSchedule(getItemsByKey(day) )}>
                                                    <img alt={ "Logo" } src={ "/media/icons/deleteIconGray.svg" }
                                                         className={ "w-4 h-4" }/>
                                                </button>
                                            }
                                        </div>
                                        { getDayContent(day) }
                                    </div>
                            }
                        </div>
                    );
                }) }
                { Array.from({length: endDayOfWeek === 0 ? 0 : 7 - endDayOfWeek}).map((_, index) => (
                    <div key={ `empty-${ index }` }
                         className={ "p-[6px] min-h-[120px] flex-grow min-w-0 flex flex-col border-r border-b" }>
                        <div className={ "CalendarDayNumber" }>
                            { index + 1 }
                        </div>
                    </div>
                )) }
            </div>
        </div>
    );
};

export default Calendar;